import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { useI18n } from '@whizz/react-i18n';
import { ChoiceGroup } from '../../../../components';

type Props = {
  id: string,
  selectAllProps: {
    indeterminate: boolean;
    checked: boolean;
    onChange(): void
  };
  children: React.ReactNode
};

const SelectStudentsTableLayout = ({ id, selectAllProps, children }: Props): JSX.Element => {

  const { translate } = useI18n();

  return (
    <React.Fragment>
      <GlobalStyle />
      <div className={'font-bold text-xl mb-md'}>
        {translate('pages.TOPIC.SELECT')}
      </div>
      <div className={'mb-md'}>
        <ChoiceGroup
          id={`${id}_all`}
          label={translate('pages.TOPIC.SELECT_ALL')}
          {...selectAllProps}
        />
      </div>
      {children}
    </React.Fragment>
  );
};

const GlobalStyle = createGlobalStyle`
  table {
    [data-column='cell_topic_age'] {
      text-align: left;   
    }
    [data-id='col_topic_age'] {
      div {
        justify-content: start !important;
      }
    }
  }
`;

SelectStudentsTableLayout.displayName = 'SelectStudentsTableLayout';

export default SelectStudentsTableLayout;
